import { SlotItem } from '../../slots/data-access/slots.models';

export interface BuildSlotBlockParams
{
  firstSlotId: string;
  allSlots: SlotItem[];
  requiredDurationMinutes: number;
  slotDurationMinutes: number;
  allowReserved?: boolean;
}

export function buildContiguousSlotBlock(
  params: BuildSlotBlockParams
): string[]
{
  const {
    firstSlotId,
    allSlots,
    requiredDurationMinutes,
    slotDurationMinutes,
    allowReserved = false
  } = params;

  const requiredSlotCount = Math.ceil(requiredDurationMinutes / slotDurationMinutes);

  const sortedSlots = [...allSlots].sort((a, b) =>
    new Date(a.startTime).getTime() - new Date(b.startTime).getTime()
  );

  const firstIndex = sortedSlots.findIndex((slot) => slot.id === firstSlotId);

  if (firstIndex < 0)
  {
    return [];
  }

  const selectedSlots = sortedSlots.slice(firstIndex, firstIndex + requiredSlotCount);

  if (selectedSlots.length !== requiredSlotCount)
  {
    return [];
  }

  for (let index = 0; index < selectedSlots.length; index += 1)
  {
    const currentSlot = selectedSlots[index];

    const isAllowedStatus =
      currentSlot.status === 'available' ||
      (allowReserved && currentSlot.status === 'reserved');

    if (!isAllowedStatus)
    {
      return [];
    }

    if (index === 0)
    {
      continue;
    }

    const previousSlot = selectedSlots[index - 1];

    if (previousSlot.deviceId && previousSlot.deviceId !== currentSlot.deviceId)
    {
      return [];
    }

    if (previousSlot.endTime !== currentSlot.startTime)
    {
      return [];
    }
  }

  return selectedSlots.map((slot) => slot.id);
}
